import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

type RadioButtonProps = {
  checked?: boolean;
  groupName: string;
  content: () => ReactNode;
  value: any;
  onChange?: () => void;
  onClick?: () => void;
};

const RadioButton: FC<RadioButtonProps> = ({
  checked = false,
  groupName,
  content,
  value,
  onChange,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Container>
      <Radio
        checked={checked}
        type='radio'
        value={value}
        name={groupName}
        onClick={handleClick}
      />
      <ContentWrapper>{content()}</ContentWrapper>
    </Container>
  );
};

export default RadioButton;

const Container = styled.label`
  cursor: pointer;
`;
const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 1px;
`;

const Radio = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  & + ${ContentWrapper} {
    cursor: pointer;
  }

  &:checked + ${ContentWrapper} {
    border: 2px solid black;
    border-radius: 4px;
  }
`;
